import convertUnicodeToEmoji from "./convertUnicodeToEmoji";
import emojiList from "./emojiList";
const getGroupEmojis = (category) => {
  return emojiList[category].map((unicode) => {
    return convertUnicodeToEmoji(unicode);
  });
};
var getGroupEmojis_default = getGroupEmojis;
export {
  getGroupEmojis_default as default
};
//# sourceMappingURL=getGroupEmojis.js.map
